import { call, all, takeEvery, put, fork } from 'redux-saga/effects';
import { notification } from '@isomorphic/shared/isomorphic/components';
import actions from './actions';
import SuperFetch from '../../helpers/superFetch';

export function* accesses() {
  yield takeEvery(actions.ACCESS_SEARCH, function*({ queryString }) {
    console.log('GET access queryString:');
    console.log(JSON.stringify(queryString));
    const response = yield call(SuperFetch.get, 'access?' + queryString);
    console.log('RESPONSE access:');
    console.log(JSON.stringify(response));
    if (response.Status !== 'error' && !response.error) {
      let accesses = response.Data.AccessLevels;
      yield put({
        type: actions.ACCESS_SEARCH_SUCCESS,
        accesses: accesses,
      });
    } else {
      yield put({
        type: actions.ACCESS_ERROR,
        accessError: Math.floor(Date.now() / 1000),
      });
      yield notification('error', response.Message, '', true); //allow silent if server error
    }
  });
}

export function* accessActions() {
  yield takeEvery(actions.ACCESS_ACTIONS_SEARCH, function*({ queryString }) {
    console.log('GET access/actions queryString:');
    console.log(JSON.stringify(queryString));
    const response = yield call(
      SuperFetch.get,
      'access/actions?' + queryString
    );
    console.log('RESPONSE access actions:');
    console.log(JSON.stringify(response));
    if (response.Status !== 'error' && !response.error) {
      let accessActions = response.Data.Actions;
      console.log('setting access actions');
      yield put({
        type: actions.ACCESS_ACTIONS_SEARCH_SUCCESS,
        accessActions: accessActions,
      });
    } else {
      yield put({
        type: actions.ACCESS_ERROR,
        accessError: Math.floor(Date.now() / 1000),
      });
      yield notification('error', response.Message, '', true); //allow silent if server error
    }
  });
}

export function* accessCreate() {
  yield takeEvery(actions.ACCESS_CREATE, function*({ createdAccess }) {
    let accesses = [];
    accesses.push(createdAccess);
    const data = { Data: { AccessLevels: accesses } };
    console.log('POST access/create json:');
    console.log(JSON.stringify(data));
    const response = yield call(SuperFetch.post, 'access/create', data);
    console.log('RESPONSE access/create:');
    console.log(JSON.stringify(response));
    if (response.Status !== 'error' && !response.error) {
      let accessCreateSuccess = response.Data.AccessLevels[0];
      yield put({
        type: actions.ACCESS_CREATE_SUCCESS,
        accessCreateSuccess: accessCreateSuccess,
      });
    } else {
      yield put({
        type: actions.ACCESS_ERROR,
        accessError: Math.floor(Date.now() / 1000),
      });
      yield notification('error', response.Message);
    }
  });
}

export function* accessUpdate() {
  yield takeEvery(actions.ACCESS_UPDATE, function*({ updatedAccess }) {
    let accesses = [];
    accesses.push(updatedAccess);
    const data = { Data: { AccessLevels: accesses } };
    console.log('POST access/update json:');
    console.log(JSON.stringify(data));
    const response = yield call(SuperFetch.post, 'access/update', data);
    console.log('RESPONSE access/update:');
    console.log(JSON.stringify(response));
    if (response.Status !== 'error' && !response.error) {
      let accessUpdateSuccess = response.Data.AccessLevels[0];
      yield put({
        type: actions.ACCESS_UPDATE_SUCCESS,
        accessUpdateSuccess: accessUpdateSuccess,
      });
    } else {
      yield put({
        type: actions.ACCESS_ERROR,
        accessError: Math.floor(Date.now() / 1000),
      });
      yield notification('error', response.Message);
    }
  });
}

export function* accessDelete() {
  yield takeEvery(actions.ACCESS_DELETE, function*({ deletedAccess }) {
    var queryString = 'ID=' + deletedAccess.ID;
    console.log('POST access/delete queryString:');
    console.log(JSON.stringify(queryString));
    const response = yield call(
      SuperFetch.delete,
      'access/delete?' + queryString
    );
    if (response.Status !== 'error' && !response.error) {
      let accessDeleteSuccess = deletedAccess;
      yield put({
        type: actions.ACCESS_DELETE_SUCCESS,
        accessDeleteSuccess: accessDeleteSuccess,
      });
    } else {
      yield put({
        type: actions.ACCESS_ERROR,
        accessError: Math.floor(Date.now() / 1000),
      });
      yield notification('error', response.Message);
    }
  });
}

/*
Saga loader
*/
export default function* rootSaga() {
  yield all([
    fork(accesses),
    fork(accessActions),
    fork(accessCreate),
    fork(accessUpdate),
    fork(accessDelete),
  ]);
}
